var _class, _DataCatalog;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import defined from "terriajs-cesium/Source/Core/defined";
import SearchHeader from "../Search/SearchHeader";
import Styles from "./data-catalog.scss";
import DataCatalogMember from "./DataCatalogMember";

// Displays the data catalog.
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
let DataCatalog = observer(_class = (_DataCatalog = class DataCatalog extends Component {
  render() {
    var _searchState$catalogS;
    const searchState = this.props.viewState.searchState;
    const isSearching = searchState.catalogSearchText.length > 0;
    const catalogSearchProvider = searchState.catalogSearchProvider;
    const unfilteredItems = isSearching && catalogSearchProvider && (_searchState$catalogS = searchState.catalogSearchResults) !== null && _searchState$catalogS !== void 0 && _searchState$catalogS.results ? searchState.catalogSearchResults.results.map(result => result.catalogItem) : this.props.items;
    const items = (unfilteredItems || []).filter(defined);
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("ul", {
      className: Styles.dataCatalog,
      children: [isSearching && catalogSearchProvider && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("label", {
          className: Styles.label,
          children: t("search.resultsLabel")
        }), /*#__PURE__*/_jsx(SearchHeader, {
          searchResults: searchState.catalogSearchResults,
          isWaitingForSearchToStart: searchState.isWaitingToStartCatalogSearch
        })]
      }), items.map(item => item !== this.props.terria.catalog.userAddedDataGroup && /*#__PURE__*/_jsx(DataCatalogMember, {
        viewState: this.props.viewState,
        member: item
        // manage group `isOpen` flag locally if searching through models dynamically (i.e. not using catalog index)
        // This must be false if resultsAreReferences - so group references open correctly in the search
        ,
        manageIsOpenLocally: isSearching && !catalogSearchProvider.resultsAreReferences,
        onActionButtonClicked: this.props.onActionButtonClicked,
        removable: this.props.removable,
        terria: this.props.terria,
        isTopLevel: true
      }, item.uniqueId))]
    });
  }
}, _defineProperty(_DataCatalog, "propTypes", {
  terria: PropTypes.object,
  viewState: PropTypes.object,
  items: PropTypes.array,
  onActionButtonClicked: PropTypes.func,
  removable: PropTypes.bool,
  t: PropTypes.func.isRequired
}), _DataCatalog)) || _class;
export default withTranslation()(DataCatalog);